//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$NewsletterController_getRecipients,
  Response$NewsletterController_getRecipients$Status$200,
  ResponseContentType$NewsletterController_getRecipients,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useNewsletterController_getRecipients = (options: {
  params: Params$NewsletterController_getRecipients['parameter'];
  config?: QueryOptions<
    Response$NewsletterController_getRecipients$Status$200[ResponseContentType$NewsletterController_getRecipients]
  >;
}) =>
  useApiClient<
    Params$NewsletterController_getRecipients,
    Response$NewsletterController_getRecipients$Status$200[ResponseContentType$NewsletterController_getRecipients]
  >({
    method: 'NewsletterController_getRecipients',
    params: { parameter: options.params },
    config: options.config,
  });
